import IconDoubleArrow from '../Icons/IconDoubleArrow.svg';
import { logClick } from 'ff/common/SegmentAnalytics';
import { hasDispatchLowca, hasJeppesenMaDispatch } from 'ff/common/system';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/FFMenu';

export default function appendCollapseButton(
    root: ShadowRoot,
    params: RenderMenuParams
) {
    const el = document.createElement('div');
    el.setAttribute('id', 'collapse-btn');
    el.style.height = '17px';
    if (
        params?.initialize?.navMenuSizeLocked == undefined ||
        params?.initialize?.navMenuSizeLocked === false
    ) {
        //set icon
        const img = document.createElement('img');
        img.setAttribute('src', IconDoubleArrow);
        el.appendChild(img);
        // add click listener
        el.addEventListener('click', () => {
            logClick(el, 'FFMenu, Collapse Width Btn');
            collapseView(root);
        });
    }
    root.appendChild(el);
}

export function collapseView(root: ShadowRoot, initRun?: boolean) {
    const rootId =
        hasDispatchLowca() || hasJeppesenMaDispatch()
            ? 'logo-with-jeppesen'
            : 'logo-with-boeing';
    root.getElementById(rootId).classList.toggle('x-collapse');
    root.querySelectorAll('.ffmenu-item').forEach(d =>
        d.classList.toggle('x-collapse')
    );
    root.getElementById('collapse-btn').classList.toggle('x-collapse');
    if (!initRun) {
        document
            .getElementById('ffweb-side-menu')
            .classList.toggle('x-collapse');
        localStorage.setItem(
            'sidebar_collapsed',
            (!isSavedAsCollapsed()).toString()
        );
    }
}

export function isSavedAsCollapsed() {
    return localStorage.getItem('sidebar_collapsed') === 'true';
}
